import { Component, ContentChild, Directive, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { ModalClasses } from '../modal.model';

@Directive({
  selector: '[modal-header]',
  standalone: false,
})
export class SbModalHeaderDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[modal-body]',
  standalone: false,
})
export class SbModalBodyrDirective {
  @Input() classes: string;
}

@Directive({
  selector: '[modal-footer]',
  standalone: false,
})
export class SbModalFooterDirective {
  @Input() classes: string;
}

@Component({
  selector: 'sb-modal-template',
  templateUrl: './sb-modal-template.component.html',
  styleUrls: ['./sb-modal-template.component.scss'],
  standalone: false,
})
export class SbModalTemplateComponent implements OnInit {
  @ContentChild(SbModalHeaderDirective, { static: false }) header?: SbModalHeaderDirective;
  @ContentChild(SbModalBodyrDirective, { static: false }) body?: SbModalBodyrDirective;
  @ContentChild(SbModalFooterDirective, { static: false }) footer?: SbModalHeaderDirective;
  @Input() templateId: string;

  protected classes: ModalClasses = {};
  constructor(private state: SbModalState) {}

  ngOnInit(): void {
    this.classes = this.state.options.get(this.templateId)?.modalClasses;
  }

  cancel() {
    this.state.modals.get(this.templateId).dismiss();
  }
}
